export default __webpack_public_path__ + "static/media/List-documentation.70f18245.md";